<!-- Start Code added by Sanchit on 14/05/2026 -->
<wm-common-confirmation-modal
  [data]="modalData"
  (onYesClick)="testWorkflow()"
  (onNoClick)="close()"
  [isApplicantMobileview]="true"
>
  <div class="dialog-content">
    <div
      *ngIf="testAsClientForm?.controls?.testClient"
      [formGroup]="testAsClientForm"
    >
      <div class="section">
        <wm-common-dropdown
          [data]="{
            label: 'Select Client to Test As',
            options: testAsClients,
            bindLabel: 'displayName',
            bindValue: 'id',
            placeholder: 'Select Client'
          }"
          formControlName="testClient"
          (change)="testAsClientSelected($event?.id || $event)"
        >
        </wm-common-dropdown>

        <app-loader *ngIf="!testAsClients"></app-loader>
      </div>

      <div class="section" *ngIf="needs?.needsParcelDataSource">
        <div class="label">Parcel Data Source</div>

        <div class="value muted">
          Parcel Data Source is configured for this jurisdiction.
        </div>
      </div>

      <div class="section" *ngIf="needs?.needsMapService">
        <wm-common-dropdown
          [data]="{
            options: testAsMapServices || [],
            bindLabel: 'name',
            bindValue: 'id',
            placeholder: 'Select Map Service'
          }"
          formControlName="testMapService"
        >
        </wm-common-dropdown>
      </div>

      <div class="section" *ngIf="needs?.needsContractorType">
        <wm-common-dropdown
          [data]="{
            options: testAsContractorTypes,
            bindLabel: 'name',
            bindValue: 'id',
            placeholder: 'Select Contractor Type'
          }"
          formControlName="testContractorType"
        >
        </wm-common-dropdown>
      </div>
    </div>

    <div *ngIf="isLoading" class="data-table-loader">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="48"
      >
      </mat-progress-spinner>

      <wm-common-text
        [data]="{
          text: 'Retrieving data, please wait...'
        }"
      >
      </wm-common-text>
    </div>
  </div>
</wm-common-confirmation-modal>
<!-- End Code added by Sanchit on 14/05/2026 -->
